import s from './SelectionsSection.module.sass'

import { FC } from 'react'
import { useAppSelector } from '@app/model/store/client'
import { CompilationGrid } from '@widgets/News/CompilationGrid'
import { SectionTitle } from '@shared/ui/Layout/SectionTitle'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { TypeMappingSelectionOutput } from '@shared/api/middleware/mappingAPI/selection/type'

interface Props {
  selectionsList: TypeMappingSelectionOutput[]
  skeleton?: boolean
}

const SelectionsSection: FC<Props> = ({ selectionsList, skeleton = false }) => {
  const storeCurrentCity = useAppSelector((store) => store.global.currentCity)
  const citySlug = storeCurrentCity?.slug

  return (
    <BlockBoundary>
      <div className={s['selections-wrap']}>
        <SectionTitle
          title={'Подборки Афиши Рестораны'}
          link={citySlug ? `/${citySlug}/restaurants/afisha_selected/` : undefined}
          skeleton={skeleton}
        />

        <CompilationGrid
          type={'selections'}
          counts={'6 6 4'}
          list={selectionsList}
          analytic={{
            section_name: 'Подборки Афиши Рестораны',
          }}
          skeleton={skeleton}
        />
      </div>
    </BlockBoundary>
  )
}
export default SelectionsSection
